// extracted by mini-css-extract-plugin
export default {"emptyState":"AoKyl","icon":"ap8hU","text":"ihMme","title":"cnIFa"};